<template>
  <v-chip label x-small :color="color" text-color="white" class="font-weight-bold px-2">
    {{ label }}
  </v-chip>
</template>
<script>
export default {
  computed: {
    label() {
      const labels = {
        open: "Open",
        confirmed: "Confirmed",
        cancelled: "Cancelled",
      };
      return labels[this.params.value] || this.params.value;
    },
    color() {
      const colors = {
        open: "amber darken-2",
        confirmed: "green darken-1",
        cancelled: "red darken-1",
      };
      return colors[this.params.value] || "grey";
    },
  },
};
</script>
